/* eslint-disable no-unused-vars */
const removeKeysWithValue = (obj, value = undefined) => Object.fromEntries(
  Object.entries(obj).filter(([_, v]) => v !== value),
);
export default removeKeysWithValue;
